import Blog from './blog/Blog.js';

export default Blog